import { useEffect } from 'react';

import { AUTH_CHANGE_TRIGGER } from '../authTokenUtils';

/**
 * Log in/out across all tabs. Tabs communicate with each other by listening to changes to a local
 * storage key. This key is set to latest timestamp whenever a user logs in or out, which causes
 * the `storage` even to be dispatched. `storage` events are only triggered in tabs _other_ than
 * the one where the user login/logout interaction was performed, according to web storage spec:
 * See https://developer.mozilla.org/en-US/docs/Web/API/Window/storage_event
 */
export const useLogoutAcrossTabs = (enableCrossTabLogout: boolean) => {
  useEffect(() => {
    const handleStorageEvent = (event: StorageEvent) => {
      if (enableCrossTabLogout && event.key === AUTH_CHANGE_TRIGGER) {
        window.location.assign('/auth/login');
      }
    };
    window.addEventListener('storage', handleStorageEvent);
    return () => window.removeEventListener('storage', handleStorageEvent);
  }, [enableCrossTabLogout]);
};
